import Vue from 'vue'

Vue.filter('dateFormatShortWithTime', (string) => {
  const dateObj = new Date(string)
  return new Intl.DateTimeFormat('fr-CA', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(dateObj)
})
